module.exports = __webpack_public_path__ + "media/components/page-payment/delivery-icon-a9e646dc0f33763490efe055019ccb3c.svg";